import { PageSeoClientTitleBlock } from './pageSeoClientTitleBlock';
import { PageSeoTitleBlockProps } from './types';

import { generateSignedImagesUrls } from '@/shared/lib/imgproxy/generateSignedImagesUrls';

export const PageSeoTitleBlock = async (props: PageSeoTitleBlockProps) => {
  const images = await generateSignedImagesUrls({
    mainLightRound: '/images/main-light-round.png',
    mainGrid: '/images/main-grid.png',
  });

  return <PageSeoClientTitleBlock images={images} {...props} />;
};
